var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManu3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BP-My-BP-details",
    transform: "translate(-41.000000, -329.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-nav",
    transform: "translate(-5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:star-copy",
    transform: "translate(44.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.86,7.442 L10,3.06 L8.138,7.447 L3.395,7.862 L6.991,10.989 L5.921,15.629 L10.006,13.174 L14.086,15.626 L13.015,10.982 L16.608,7.859 L11.86,7.443 L11.86,7.442 Z M15.591,17.695 L10.006,14.339 L4.416,17.698 L5.882,11.348 L0.96,7.07 L7.451,6.503 L10,0.5 L12.546,6.498 L19.042,7.067 L14.124,11.342 L15.591,17.695 Z",
    id: "Icon-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManu3);
export default __webpack_public_path__ + "static/media/manu3.8316e9fcfdd276061ce8a58d09573faf.svg";
export { ForwardRef as ReactComponent };